import { render } from "./Social.vue?vue&type=template&id=0d451cc2"
import script from "./Social.vue?vue&type=script&lang=js"
export * from "./Social.vue?vue&type=script&lang=js"

import "./Social.vue?vue&type=style&index=0&id=0d451cc2&lang=scss"

import exportComponent from "/Users/luke/Documents/contility/server/src/views/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__